
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/hooks/useAuth';
import { Zap } from 'lucide-react';

interface AdminRouteProps {
    children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { isAdmin, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-900">
                <Zap className="h-12 w-12 text-primary animate-spin" />
            </div>
        );
    }

    if (!isAdmin) {
        // 관리자가 아니면 로그인 페이지로 리다이렉트
        console.warn("AdminRoute: Access denied. User is not an admin.", { isAdmin, loading });
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default AdminRoute;
